<div class="ab-notice-view__tab">
  <div
    class="alert alert-warning alert--small"
    *ngIf="group.errors[0].type === 'AirbrakeNotice'"
  >
    This error was generated by Airbrake, because we
    <a
      class="alert-link"
      href="https://docs.airbrake.io/docs/faq/rejected-errors/"
      target="_self"
      >could not parse the error</a
    >
    sent by your notifier. See Parameters and Context sections in the
    Occurrences tab for details.
  </div>
  <div
    class="alert alert-info alert--small"
    *ngIf="group.noticeSampledCount > 0"
  >
    This error has an extremely high number of occurrences. As a result, we are
    not storing every occurrence. Please see our
    <a
      class="alert-link"
      href="https://docs.airbrake.io/docs/faq/error-reduction-in-very-large-groups/"
      target="_self"
    >
      help doc on truncating error occurrences </a
    >.
  </div>
  <div class="row">
    <div class="col-xl-5">
      <table class="kv-table">
        <tr>
          <td class="kv-table__key kv-table__kv--no-top-padding">First seen</td>
          <td class="kv-table__value kv-table__kv--no-top-padding">
            <ab-timestamp
              class="ab-timestamp"
              [time]="group.createdAt"
              [placement]="'right auto'"
            ></ab-timestamp
            ><span *ngIf="!featuresLoading"
              ><span *ngIf="groupDeployAvailable === true"
                ><span *ngIf="deployDashEnabled">
                  after
                  <a
                    uiSref="deploys-show"
                    [uiParams]="{
                      projectId: project.id,
                      deployId: group.deployId
                    }"
                    >deploy</a
                  ></span
                ><span *ngIf="!deployDashEnabled">
                  after unknown deploy (<a
                    href="https://docs.airbrake.io/docs/features/deploy-tracking/"
                    >enable deploy tracking</a
                  >)</span
                ></span
              ><span *ngIf="groupDeployAvailable === false">
                after
                <span
                  ngbTooltip="Deploy deleted according to your plan's data retention rules"
                  placement="top"
                  container="body"
                  ><span class="text-dotted">deploy</span></span
                ></span
              ></span
            >
          </td>
        </tr>
        <tr>
          <td class="kv-table__key">Last seen</td>
          <td class="kv-table__value">
            <ab-timestamp
              class="ab-timestamp"
              [time]="group.lastNoticeAt"
              [placement]="'right auto'"
            ></ab-timestamp>
          </td>
        </tr>
        <tr>
          <td class="kv-table__key">Occurrences</td>
          <td class="kv-table__value">
            <ab-occurrences [group]="group"></ab-occurrences>
          </td>
        </tr>
        <tr *ngIf="notice.errors[0].type">
          <td class="kv-table__key">Error type</td>
          <td class="kv-table__value">{{ notice.errors[0].type }}</td>
        </tr>
        <tr *ngIf="notice.context.environment">
          <td class="kv-table__key">Environment</td>
          <td class="kv-table__value">
            <ab-env-label [env]="notice.context.environment"></ab-env-label>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-xl-7">
      <div class="occurrence-graph">
        <div class="occurrence-graph__controls">
          <div class="occurrence-graph__legend">Chart times in UTC</div>
          <ab-time-dur-switch
            [enabled]="!loadingChart"
            [dur]="dur"
            [lastN]="lastN"
            (changed)="onTimeDurChange($event)"
          ></ab-time-dur-switch>
        </div>

        <div class="content-mask-container">
          <div class="content-mask" *ngIf="loadingChart">
            <ab-spinner></ab-spinner>
          </div>
          <div class="ab-chart occurrence-graph__barchart">
            <ab-bar-chart
              class="ab-chart__chart"
              [config]="chart"
            ></ab-bar-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table class="kv-table">
    <tr *ngIf="notice.context.severity">
      <td class="kv-table__key">Severity</td>
      <td class="kv-table__value">{{ notice.context.severity }}</td>
    </tr>
    <tr
      *ngIf="notice.errors[0].backtrace && notice.errors[0].backtrace[0].file"
    >
      <td class="kv-table__key">File</td>
      <td class="kv-table__value">
        <ab-file-line
          [file]="notice.errors[0].backtrace[0].file"
          [line]="notice.errors[0].backtrace[0].line"
          [repoUrl]="repoUrl"
          [gitRevision]="deployRevision"
          [rootDir]="notice.context.rootDirectory"
        ></ab-file-line>
      </td>
    </tr>
    <tr *ngIf="notice.context.component || notice.context.action">
      <td class="kv-table__key">Where</td>
      <td class="kv-table__value">
        {{ notice.context.component }}#{{ notice.context.action }}
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <table class="kv-table kv-table--lg-flex" *ngIf="notice.context.route">
          <tr class="kv-table__no-shrink">
            <td class="kv-table__key">ROUTE</td>
            <td class="kv-table__value">
              <span *ngIf="routeStats"
                ><b>{{ routeStats.errorRate | rateFormat }}% error rate</b
                ><b>
                  from {{ routeStats.requestCount | numberToHuman }}
                  {{ routeStats.requestCount | pluralize: "request" }} to this
                  route:</b
                ></span
              ><span class="kv-table__url">
                <ab-route-method
                  [method]="notice.context.httpMethod"
                ></ab-route-method
                >&nbsp;<a
                  *ngIf="notice.context.routeId"
                  uiSref="routes-show"
                  [uiParams]="{
                    routeId: notice.context.routeId,
                    dur: dur,
                    last_n: lastN
                  }"
                >
                  <ab-route-name
                    [routeName]="notice.context.route"
                  ></ab-route-name
                ></a>
                <ab-route-name
                  *ngIf="!notice.context.routeId"
                  [routeName]="notice.context.route"
                ></ab-route-name
              ></span>
            </td>
          </tr>
          <tr class="url" *ngIf="showRouteApmCta">
            <td colspan="2">
              <span class="kv-table__cta"
                ><span
                  >Find out how often this route is failing with&nbsp;<strong
                    >Airbrake Performance Monitoring&nbsp;</strong
                  ></span
                ><a
                  class="kv-table__no-shrink btn btn--success"
                  uiSref="project-performance"
                  [uiParams]="{ projectId: project.id }"
                  >Try it for FREE</a
                ></span
              >
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
  <h4 class="kv-table__title">Last occurrence</h4>
  <table class="kv-table">
    <tr class="url" *ngIf="notice.context.url">
      <td class="kv-table__key">URL</td>
      <td class="kv-table__value">
        <span *ngIf="notice.context.httpMethod">{{
          notice.context.httpMethod
        }}</span
        ><a
          class="kv-table__url external-link"
          href="{{ notice.context.url }}"
          target="_blank"
          >{{ notice.context.url }}</a
        >
      </td>
    </tr>
    <tr *ngIf="notice.context.version">
      <td class="kv-table__key">Version</td>
      <td class="kv-table__value">{{ notice.context.version }}</td>
    </tr>
    <tr *ngIf="notice.context.hostname">
      <td class="kv-table__key">Hostname</td>
      <td class="kv-table__value">{{ notice.context.hostname }}</td>
    </tr>
    <tr *ngIf="notice.errors[0].message">
      <td class="kv-table__key">Error message</td>
      <td class="kv-table__value">{{ notice.errors[0].message }}</td>
    </tr>
    <tr *ngIf="notice.context.userAddr">
      <td class="kv-table__key">User address</td>
      <td class="kv-table__value">
        {{ notice.context.userAddr }}
        <ab-country
          *ngIf="notice.context.userCountry"
          [country]="notice.context.userCountry"
          [code]="notice.context.userCountryCode"
        ></ab-country>
      </td>
    </tr>
    <tr>
      <td class="kv-table__key">Remote address</td>
      <td class="kv-table__value">
        {{ notice.context.remoteAddr }}
        <ab-country
          *ngIf="notice.context.remoteCountry"
          [country]="notice.context.remoteCountry"
          [code]="notice.context.remoteCountryCode"
        ></ab-country>
      </td>
    </tr>
    <tr *ngIf="notice.context.userAgent">
      <td class="kv-table__key">User agent</td>
      <td class="kv-table__value">
        <ab-user-agent
          [raw]="notice.context.userAgent"
          [info]="notice.context.userAgentInfo"
        ></ab-user-agent>
      </td>
    </tr>
  </table>
  <div>
    <hr />
    <table class="kv-table">
      <tr>
        <td class="kv-table__key">Integrations</td>
        <td
          class="kv-table__value"
          *ngIf="shouldShowIntegrationButtons === false"
        >
          <div class="row mb-3">
            <div class="col-xl-8">
              Create issues and tickets with a single click, get error
              notifications instantly via chat, or use webhooks and our API to
              build custom integrations that enhance your workflow.
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-xl-8">
              <div class="d-sm-flex d-md-block d-lg-flex">
                <div class="integration-logo integration-logo--slack"></div>
                <div class="integration-logo integration-logo--github"></div>
                <div class="integration-logo integration-logo--bitbucket"></div>
                <div class="integration-logo integration-logo--trello"></div>
                <div class="integration-logo integration-logo--webhooks"></div>
                <div class="integration-logo integration-logo--jira"></div>
              </div>
            </div>
          </div>
          <button
            class="btn btn--upgrade"
            *ngIf="integrationsEnabled === false"
            (click)="openUpgradeModal($event)"
            data-feature="integrations"
            type="button"
          >
            Enable Integrations</button
          ><a
            class="btn"
            *ngIf="showConfigureIntegrationsButton === true"
            href="/projects/{{ project.id }}/services"
            target="_self"
            >Connect your apps</a
          >
        </td>
        <td
          class="kv-table__value"
          *ngIf="shouldShowIntegrationButtons === true"
        >
          <a href="/projects/{{ project.id }}/services" target="_self"
            >Integration settings</a
          >
        </td>
      </tr>
    </table>
  </div>
  <table class="integrations kv-table" *ngIf="shouldShowIntegrationButtons">
    <ng-container
      *ngFor="
        let integration of project.integrations | keyvalue;
        trackBy: trackByIndex
      "
    >
      <tr *ngIf="isIssueService(integration.key)">
        <td class="kv-table__key">{{ integration.key | titleize }}</td>
        <td class="kv-table__value" [ngSwitch]="integration.key">
          <ab-github-integration
            *ngSwitchCase="'github'"
            [fields]="integration.value"
            [notice]="notice"
          ></ab-github-integration>
          <ab-pivotal-integration
            *ngSwitchCase="'pivotalTracker'"
            [notice]="notice"
          ></ab-pivotal-integration>
          <ab-lighthouse-integration
            *ngSwitchCase="'lighthouse'"
            [notice]="notice"
          ></ab-lighthouse-integration>
          <ab-jira-integration
            *ngSwitchCase="'jira'"
            [notice]="notice"
          ></ab-jira-integration>
          <ab-assembla-integration
            *ngSwitchCase="'assembla'"
            [notice]="notice"
          ></ab-assembla-integration>
          <ab-bitbucket-integration
            *ngSwitchCase="'bitbucket'"
            [notice]="notice"
          ></ab-bitbucket-integration>
          <ab-trello-integration
            *ngSwitchCase="'trello'"
            [notice]="notice"
          ></ab-trello-integration>
          <ab-gitlab-integration
            *ngSwitchCase="'gitlab'"
            [fields]="integration.value"
            [notice]="notice"
          ></ab-gitlab-integration>
        </td>
      </tr>
    </ng-container>
  </table>
  <hr />
  <table class="kv-table">
    <tr>
      <td class="kv-table__key">Notifications</td>
      <td class="kv-table__value" *ngIf="mutingEnabled === false">
        <div class="row mb-3">
          <div class="col-xl-8">
            Muting an error will prevent notifications from being sent for that
            error but the error will be visible on your dashboard and marked as
            muted.
          </div>
        </div>
        <button
          class="btn btn--upgrade"
          (click)="openUpgradeModal($event)"
          data-feature="muting"
          type="button"
        >
          Enable Muting
        </button>
      </td>
      <td class="kv-table__value" *ngIf="mutingEnabled === true">
        <button
          class="btn"
          *ngIf="!group.muted"
          (click)="muteGroup(group)"
          type="button"
        >
          Mute for this error
        </button>
        <button
          class="btn"
          *ngIf="group.muted"
          (click)="unmuteGroup(group)"
          type="button"
        >
          Unmute for this error
        </button>
      </td>
    </tr>
  </table>
  <hr />
  <table class="kv-table">
    <tr>
      <td class="kv-table__key">Error</td>
      <td class="kv-table__value">
        <button
          class="btn"
          (click)="deleteGroup()"
          [disabled]="deletingGroup"
          type="button"
        >
          Delete
        </button>
      </td>
    </tr>
  </table>
</div>
